// Trimmed store: Import Hub only needs a handful of formatting helpers plus
// a small team-member lookup for owner/actor display. All Export-side state
// (Zustand store, licenses, screenings, BOM, etc.) has been removed.

import { countries } from '../../../utils/countriesWithCodes';

const ISO2_TO_NAME: Record<string, string> = Object.fromEntries(
  countries.map((c) => [c.iso2.toUpperCase(), c.name]),
);

// Real products store country_of_origin as an ISO-2 code (e.g. "CN") — set
// by the legacy tool's country picker — while mock data and free-text entry
// use full names. WorldMap matches by full country name, so anything that
// aggregates country_of_origin for the map needs to normalize through this
// first. Non-ISO2 / unrecognized values pass through unchanged.
export const countryNameFromCode = (value: string): string =>
  (value.length === 2 && ISO2_TO_NAME[value.toUpperCase()]) || value;

export type TeamMember = { id: string; name: string; email?: string; avatarColor?: string };

export const TEAM_MEMBERS: TeamMember[] = [
  { id: "u-alex", name: "Alex Chen", email: "alex@example.com", avatarColor: "#4f46e5" },
  { id: "u-priya", name: "Priya Shah", email: "priya@example.com", avatarColor: "#0ea5e9" },
  { id: "u-sam", name: "Sam Rivera", email: "sam@example.com", avatarColor: "#10b981" },
  { id: "u-jordan", name: "Jordan Kim", email: "jordan@example.com", avatarColor: "#f59e0b" },
  { id: "u-morgan", name: "Morgan Lee", email: "morgan@example.com", avatarColor: "#ef4444" },
];

export const formatCurrency = (n: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(n);

export const formatDate = (s: string) =>
  new Date(s).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

export const daysUntil = (s: string) => {
  const diff = new Date(s).getTime() - Date.now();
  return Math.ceil(diff / (1000 * 60 * 60 * 24));
};

export const getMember = (id?: string) => {
  if (!id) return null;
  return TEAM_MEMBERS.find((m) => m.id === id) ?? null;
};
